/* eslint-disable import/prefer-default-export */

import { gql } from "@apollo/client";

export const MENUS = gql`
  query Commitee($committeeFilter: CommitteeFilterInput!) {
    commitee(committeeFilter: $committeeFilter) {
      functionalCommittee {
        id
        committeeName
        type
        logo
        createdAt
        createdBy
      }
    }
  }
`;
